import { cloneDeep } from 'lodash'

import { Colors } from '@sigma-frontend-libs/commons'

import { components, notificationsColors, notificationsIcons, services } from '@/utils'

import squircle from '@/components/icon/squircle'
import arrow from '@/components/misc/arrow'
import dialog from '@/components/services/settingsSite/notifications/templates/_dialog'

function renderDialog(h) {
  if (this.path) {
    return h(
      dialog,
      {
        props: {
          value: this.showDialog,
          data: cloneDeep(this.settings[this.path]),
          path: this.path
        },
        on: {
          input: event => {
            this.showDialog = event
          },
          data: event => {
            this.$emit('input', event, this.path)
          }
        }
      }
    )
  }
}

function renderItemHeaderContent(h, options, owner) {
  const { path, serviceName } = options

  return h(
    'div',
    {
      class: 'row faic'
    },
    [
      h(
        squircle,
        {
          props: {
            iconSVG: notificationsIcons[owner],
            color: Colors.grey
          }
        }
      ),
      this.getTranslate(`${serviceName}.subtitles.${path}.${owner}`)
    ]
  )
}
function renderItemHeader(h, options, owner, expanded) {
  return h(
    'div',
    {
      class: 'default-expansion-panel-header pl-2'
    },
    [
      renderItemHeaderContent.call(this, h, options, owner),
      h(arrow, { props: { expanded } })
    ]
  )
}
function renderChannelHeaderContent(h, channel) {
  return h(
    'div',
    {
      class: 'row faic'
    },
    [
      h(
        squircle,
        {
          props: {
            iconSVG: channel,
            color: notificationsColors[channel]
          }
        }
      ),
      this.getTranslate(`${services.sendings}.types.${channel}`)
    ]
  )
}
function renderChannelHeader(h, channel, expanded) {
  return h(
    'div',
    {
      class: 'default-expansion-panel-header pl-2'
    },
    [
      renderChannelHeaderContent.call(this, h, channel),
      h(arrow, { props: { expanded } })
    ]
  )
}
function renderChannelTemplate(h, path, index) {
  let itemStyle
  if (index !== 0) {
    itemStyle = { 'border-top': '1px dashed grey' }
  }

  return h(
    components['list-item'],
    {
      style: itemStyle,
      props: {
        link: true,
        label: this.getTranslate(path.replace('.manager', ''))
      },
      key: path,
      on: {
        click: () => {
          this.showDialog = true
          this.path = path
        }
      }
    }
  )
}
function renderChannelTemplates(h, templates) {
  if (Array.isArray(templates) && templates.length) {
    return h(
      components.list,
      {
        props: { dense: true }
      },
      [
        templates.map((path, index) => {
          return renderChannelTemplate.call(this, h, path, index)
        })
      ]
    )
  }
}
function renderChannel(h, owner, channel) {
  return h(
    components['expansion-panel'],
    {
      scopedSlots: {
        header: ({ expanded }) => {
          return renderChannelHeader.call(this, h, channel, expanded)
        },
        default: () => {
          return renderChannelTemplates.call(this, h, this.schema.templates[owner][channel])
        }
      }
    }
  )
}
function renderChannels(h, owner) {
  return Object.keys(this.schema.templates[owner]).map(channel => {
    return renderChannel.call(this, h, owner, channel)
  })
}
function renderItemBody(h, owner) {
  if (Object.keys(this.schema.templates[owner]).length) {
    return h(
      components['expansion-panels'],
      {
        props: { flat: true }
      },
      [ renderChannels.call(this, h, owner) ]
    )
  }
}
function renderItem(h, options, owner) {
  return h(
    components['expansion-panel'],
    {
      scopedSlots: {
        header: ({ expanded }) => {
          return renderItemHeader.call(this, h, options, owner, expanded)
        },
        default: () => {
          return renderItemBody.call(this, h, owner)
        }
      }
    }
  )
}
function renderItems(h, options) {
  return Object.keys(this.schema.templates).map(owner => {
    return renderItem.call(this, h, options, owner)
  })
}

export default function(h, options) {
  if (this.settings) {
    return h(
      components['expansion-panels'],
      {
        props: {
          outline: true,
          rounded: true
        }
      },
      [
        renderItems.call(this, h, options),
        renderDialog.call(this, h)
      ]
    )
  }
}

